


import React from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaPlus } from 'react-icons/fa';

const ResourcesPage = () => {
  const resources = [
    {
      id: 1,
      title: 'Python Tutorial',
      description: 'Learn Python from beginner to advanced level.',
      path: '/python',
    },
    {
      id: 2,
      title: 'Java Tutorial',
      description: 'Master Java programming with examples and exercises.',
      path: '/java',
    },
    {
      id: 3,
      title: 'Git Tutorial',
      description: 'Learn version control with Git and GitHub.',
      path: '/git',
    },
    {
      id: 4,
      title: 'Frontend HTML, CSS, JS',
      description: 'Learn HTML, CSS, and JavaScript for frontend development.',
      path: '/frontend',
    },
    {
      id: 5,
      title: 'Flask Tutorial',
      description: 'Learn Flask for building web applications in Python.',
      path: '/flask',
    },
    {
      id: 6,
      title: 'Frontend with React',
      description: 'Learn React for building modern web applications.',
      path: '/react',
    },
    {
      id: 7,
      title: 'Backend Development',
      description: 'Learn backend development with Node.js, Express JS, and MongoDB.',
      path: '/backend',
    },
    {
      id: 8,
      title: 'Full Stack Development',
      description: 'Build full-stack web applications with modern tools.',
      path: '/fullstack',
    },
    {
      id:9,
      title :"DSA",
      description: 'Learn Data Structures and Algorithms for coding interviews.',
      path:'/dsa'

    }
  ];

  return (
   <div className="min-h-screen bg-[#0A0F20] text-white">
      {/* Main Content */}
      <div className="max-w-6xl mx-auto py-12 px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Explore Our Resources</h1>
          <p className="text-base sm:text-lg text-gray-400 max-w-2xl mx-auto">
            Learn in-demand tech skills with our curated tutorials. From coding basics to advanced development, start your journey to building apps and websites today.
          </p>
        </div>

        {/* Resources Grid */}
        <div className="mb-12">
          <h2 className="text-xl font-semibold mb-4">Learning Resources</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {resources.map((resource) => (
              <Link
                key={resource.id}
                to={resource.path}
                className="flex items-center justify-center border border-gray-600 rounded-md py-3 px-4 text-sm hover:bg-gray-800 transition-colors"
              >
                {resource.title}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Floating Button */}
      {/* <div className="fixed bottom-6 right-6">
        <button
          className="bg-white text-black rounded-full p-3 hover:bg-gray-200 transition-colors"
          onClick={() => alert('Add resource functionality to be implemented')}
        >
          <FaPlus className="w-6 h-6" />
        </button>
      </div> */}
    </div>
  );
};

export default ResourcesPage;